// extracted by mini-css-extract-plugin
export var columnList = "_fu-0";